import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { MaterialModule } from '../material.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

// Components
import { DashboardComponent } from '../dashboard/dashboard.component';
import { PerformanceComponent } from '../nudge/performance/performance/performance.component';
import { NudgesComponent } from '../nudge/nudges/nudges/nudges.component';
import { ProgressChartComponent } from '../utils/progress-chart/progress-chart.component';
import { SeoPremiumBannerComponent } from '../banners/seo-premium-banner/seo-premium-banner.component';
import { SupportChatNudgeComponent } from '../dashboard-nudges/support-chat-nudge/support-chat-nudge.component';
import { CustomBarchartComponent } from '../seo/ai-analysis/custom-barchart/custom-barchart.component';
import { DashboardShopifyComponent } from '../dashboard/dashboard-shopify/dashboard-shopify.component';
import { ShopifyNudgeCardComponent } from '../dashboard/dashboard-shopify/shopify-nudge-card/shopify-nudge-card.component';
import { ShopifySignalsTableComponent } from '../dashboard/dashboard-shopify/shopify-signals-table/shopify-signals-table.component';

// Modals
import { ConfirmationComponent } from '../modals/confirmation/confirmation.component';

// Translate module
import { TranslateModule } from '@ngx-translate/core';
// import { HttpLoaderFactory } from '../core/translate/app.translate-loader';

import { CustomPaginatorIntl } from '../utils/custom-paginator-intl.service';
import { MatPaginatorIntl } from '@angular/material/paginator';

// Pipes
import { CurrencyFormatterPipe } from '../pipes/currency-formatter.pipe';
import { NumberFormatterPipe } from '../pipes/number-formatter.pipe';
import { ButtonComponent } from './components/button/button.component';
import { GoLiveDatesComponent } from './components/go-live-dates/go-live-dates.component';

@NgModule({
  declarations: [
    DashboardComponent,
    PerformanceComponent,
    NudgesComponent,
    ConfirmationComponent,
    ProgressChartComponent,
    SeoPremiumBannerComponent,
    CurrencyFormatterPipe,
    SupportChatNudgeComponent,
    CustomBarchartComponent,
    NumberFormatterPipe,
    ButtonComponent,
    GoLiveDatesComponent,
    DashboardShopifyComponent,
    ShopifyNudgeCardComponent,
    ShopifySignalsTableComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    Ng2GoogleChartsModule,
    NgxSkeletonLoaderModule,
    TranslateModule.forChild(),
    ScrollingModule,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }],
  schemas: [NO_ERRORS_SCHEMA],
  exports: [
    DashboardComponent,
    PerformanceComponent,
    NudgesComponent,
    CommonModule,
    MaterialModule,
    Ng2GoogleChartsModule,
    NgxSkeletonLoaderModule,
    ConfirmationComponent,
    ProgressChartComponent,
    SeoPremiumBannerComponent,
    TranslateModule,
    CurrencyFormatterPipe,
    ScrollingModule,
    SupportChatNudgeComponent,
    CustomBarchartComponent,
    NumberFormatterPipe,
    ButtonComponent,
    GoLiveDatesComponent,
    DashboardShopifyComponent,
  ],
})
export class SharedModule {}
